import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.2 0 51-22.8 51-51S86.2 7 58 7 7 29.8 7 58s22.8 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M78 21.9c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M50.06 94.54a1.5 1.5 0 0 1 0 2.12l-10 10.001a1.5 1.5 0 1 1-2.12-2.122l10-10a1.5 1.5 0 0 1 2.12 0"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M37.94 94.54a1.5 1.5 0 0 1 2.12 0l10 9.999a1.501 1.501 0 0 1-2.12 2.122l-10-10a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M75.5 109.1c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M102.9 25.4a1.5 1.5 0 0 1 1.5 1.5V41a1.5 1.5 0 0 1-3 0V26.9a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M94.3 34a1.5 1.5 0 0 1 1.5-1.5h14.1a1.5 1.5 0 0 1 0 3H95.8a1.5 1.5 0 0 1-1.5-1.5M5.6 35.7c0-3.352 2.648-6 6-6s6 2.648 6 6-2.648 6-6 6-6-2.648-6-6m6-4c-2.248 0-4 1.753-4 4 0 2.248 1.752 4 4 4s4-1.752 4-4-1.752-4-4-4"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M44.7 76.7h10.8zm-21.7-5c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5h70c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5zm37.5 5h10.8z"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M90.5 71.7V31.9c0-2.7-2.1-5.1-5-5.1h-55c-2.9 0-5 2.4-5 5.1v39.8z"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="m71.3 76.7 4.4 10.9c.5 1.3 2 1.9 3.2 1.4 1.3-.5 1.9-2 1.4-3.2l-3.6-9.1zm-15.8 0v10c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-10zm-16.2 0-3.6 9.1c-.5 1.3.1 2.7 1.4 3.2s2.7-.1 3.2-1.4l4.4-10.9z"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      d="M40.5 39.2c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5H63c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5zM50.5 49.2c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5H63c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5zM60.5 61.7c0-1.4 1.1-2.5 2.5-2.5h12.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5H63c-1.4 0-2.5-1.1-2.5-2.5"
    />
  </svg>
);
const SvgEnrichedIconProjectManagementInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconProjectManagementInverted);
export default Memo;
